import React, { useState } from 'react';
import { VfModal } from '@vfit/shared/components';
import { IOffersProposalDetail } from '@vfit/consumer/providers';
import { colors } from '@vfit/shared/themes';
import SplittedProposal from './components/SplittedProposal/splittedProposal';
import { useDeviceType } from '@vfit/shared/hooks';

const OffersProposalWrapper = () => {
  const { isDesktop, isMobile } = useDeviceType();
  const initialOffersProposalModal: IOffersProposalDetail = {
    showModal: false,
    topLogo: '',
    title: '',
    description: '',
    bottomDescription: '',
    bottomDescriptionAction: () => {
      return;
    },
    bottomDescriptionActionLabel: '',
    topFirstCard: '',
    firstCard: undefined,
    topSecondCard: '',
    secondCard: undefined,
    onCloseModal: () => {
      return;
    },
  };
  const setModalHeight = () => 563;
  const [modalDetail, setModalDetail] = useState<IOffersProposalDetail>(initialOffersProposalModal);

  if (typeof document !== 'undefined') {
    document.addEventListener('offersProposalEvent', (event) => {
      const { detail } = event as CustomEvent as { detail: IOffersProposalDetail };
      setModalDetail({
        ...detail,
      });
    });
  }

  const resetModalStatus = () => {
    setModalDetail(initialOffersProposalModal);
  };

  const handleCloseModal = () => {
    modalDetail?.onCloseModal?.();
    resetModalStatus();
  };

  return (
    <VfModal
      height={setModalHeight()}
      isOpen={modalDetail?.showModal || false}
      handleClose={handleCloseModal}
      isModalFullContainer={true}
      variant={isDesktop ? 'mva' : 'sunrise'}
      enableCloseClickOutside={modalDetail?.enableCloseClickOutside || false}
      closeColor={modalDetail?.closeColor || colors.$262626}
      isDisabledClose={!modalDetail?.isShowClose || false}
    >
      <SplittedProposal {...modalDetail} onCloseModal={handleCloseModal} />
    </VfModal>
  );
};

export default OffersProposalWrapper;
